import React from 'react';
import styles from '../../assets/css/loader.module.css';

const Loading = () => {
    return (
        <div className={styles.fondo}>
            <div className={styles.loader}>Loading...</div>
        </div>
    );
};

export default Loading;
